/*equal-height*/
function equalHeight() {
	$.fn.extend({
		equalHeights: function() {
			var top = 0;
			var row = [];
			var classname = ('equalHeights' + Math.random()).replace('.', '');
			$(this).each(function() {
				var thistop = $(this).offset().top;
				if (thistop > top) {
					$('.' + classname).removeClass(classname);
					top = thistop;
				}
				$(this).addClass(classname);
				$(this).height('auto');
				var h = (Math.max.apply(null, $('.' + classname).map(function() {
					return $(this).outerHeight();
				}).get()));
				$('.' + classname).height(h);
			}).removeClass(classname);
		}
	});
	$('.leadership-listing li > a i').equalHeights();
    $('.sectors-section .sector-listing li .image-block').equalHeights();
}


  function team_toggle() {
  	$(".member_content").removeClass("hide");
  	$(".readless").removeClass("hide");
  	if($(window).width() > 1024){
  		$('.readmore').click(function(e){
          e.stopImmediatePropagation();
          $('.member_content').slideUp();
          $('.member-biodata').find('.readmore').show();
          $('.member-biodata').find('.readless').hide();
          $('.member_truncate_content').show();
          $(this).closest('.member-biodata').find('.member_content').slideDown();
          $(this).closest('.member-biodata').find('.member_truncate_content').hide();
          $(this).closest('.member-biodata').find('.readmore').hide();
          $(this).closest('.member-biodata').find('.readless').show();
    	});

		$('.readless').click(function(e){
          e.stopImmediatePropagation();
        	$('.member_content').slideUp();
      		$(this).closest('.member-biodata').find('.member_truncate_content').delay(300).show();
      		$(this).closest('.member-biodata').find('.readless').hide();
      		$(this).closest('.member-biodata').find('.readmore').show();
    	});

  	}else{
	    $('.readless').hide();
    	$('.member_content').slideUp();

  	}
  }
function hover_submenu() {
  	$('.site-nav__dropdown').fadeOut(200);
    $('.site-nav--has-dropdown').hover(function(){
    $('.site-nav__dropdown').not($(this).find('.site-nav__dropdown')).fadeOut(200);
  	$(this).find('.site-nav__dropdown').fadeIn(200);
    },
   function() {
    $(this).find('.site-nav__dropdown').fadeOut();
});
}



// function adj_mobile_nav() {
//       if ($(window).width() < 768) {
//       if($(".owl-dots").length > 0){
//         var dot_left_offset = $(".owl-dots").offset().left;
//         var prev_position = dot_left_offset - ($(".owl-nav .owl-prev").width() + 40);
//         var next_position = dot_left_offset + $(".owl-dots").width();
//         $(".owl-nav .owl-prev").css("left", prev_position + "px");
//         $(".owl-nav .owl-next").css("left", next_position + "px");
//       }
//     }else{

//       	$(".owl-nav .owl-prev").css("left", "");
//         $(".owl-nav .owl-next").css("left", "");

//       }

// }



$(document).ready(function() {

  // Download data capture popup form js start
	// console.log(jQuery.cookie('dataCaptureCookie'));


  	if($('#dataCaptureModal').length > 0){

      //$('#dataCaptureModal').insertBefore('#shopify-section-footer');
      var dataModal = document.getElementById("dataCaptureModal");
      var span = document.getElementsByClassName("close-popup")[0];
	  var is_dataCapture = jQuery.cookie('dataCaptureCookie');
      var date = new Date();

      /*$('#pdfmonkey_product_submit').on('click', function(){
        if(is_dataCapture != 'yes_set'){
        	setTimeout(function(){
              dataModal.style.display = "block";
              $('body').addClass('open-data-capture-modal');
              $('.white-paper-modal .form-title h2').text('Download Data Sheet');
              $('.zoho_submit_button button').addClass('hide');
              $('.zoho_submit_button #zoho_pdfmonkey_product_submit').removeClass('hide');

            },1000);
        }

      });*/
      $('.download-cad-block').on('click', function(){
          if(is_dataCapture == 'yes_set'){
              location.href = $('.download-cad-block').not('.download-cad-block.hide').attr('data-link');
          }else{
          	  dataModal.style.display = "flex";
              $('body').addClass('open-data-capture-modal');
              $('.white-paper-modal .form-title h2').text('Download CAD Block');
              $('.zoho_submit_button button').addClass('hide');
              $('.zoho_submit_button #zoho_download_cad').removeClass('hide');

          }
      });
      $('#download-doc-m-data').on('click', function(){

    	  if(is_dataCapture == 'yes_set'){
              Object.assign(document.createElement("a"), {
              target: "_blank",
              href: $('#download-doc-m-data').attr('data-link')
              }).click();
          }else{
          	  dataModal.style.display = "flex";
              $('body').addClass('open-data-capture-modal');
              $('.white-paper-modal .form-title h2').text('Download Product Specification');
              $('.zoho_submit_button button').addClass('hide');
              $('.zoho_submit_button #zoho_download_doc_m').removeClass('hide');

          }
      });
      /*$('.zoho_submit_button #zoho_pdfmonkey_product_submit').click(function(e){
      	e.preventDefault();
        var name = $('.data-capture-form #form input[name=SingleLine]').val();
        var email = $('.data-capture-form #form input[name=Email1]').val();
        var company = $('.data-capture-form #form input[name=SingleLine3]').val();
        var phone = $('.data-capture-form #form input[name=PhoneNumber_countrycode]').val();
        console.log('click sheet');
        if(name && email && company && phone){
          $('.zoho_submit_button #zoho_pdfmonkey_product_submit .loader').removeClass('hide');
  		  $('.zoho_submit_button #zoho_pdfmonkey_product_submit').addClass('loader-active');
          $('.data-capture-form #form #data_capture_download_btn').val('Download Data Sheet');
          $('.data-capture-form #form #data_capture_lead_source').val('Motionspot Data Sheet Download');
          console.log('validated');
          setTimeout(function(){
          	location.href = localStorage.getItem("pdf_download_url");
          	$('.zoho_submit_button #zoho_pdfmonkey_product_submit .loader').addClass('hide');
            $('.zoho_submit_button #zoho_pdfmonkey_product_submit').removeClass('loader-active');
            setTimeout(function(){
                $('.data-capture-form #form').attr('action', 'https://forms.zohopublic.eu/motionspot/form/DownloadDataEntryFormMotionspot/formperma/-Yki3iPKCGKw54BUvQROjC6rxTwUNPNOYz47O0-jyZM/htmlRecords/submit');
              	date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              	$.cookie("dataCaptureCookie", 'yes_set', { expires : date });
                $('.data-capture-form #form').submit();

            },2000);
          },3000);
        }
      });*/

      $('.zoho_submit_button #zoho_download_cad').click(function(e){

      	e.preventDefault();
        var name = $('.data-capture-form #form input[name=SingleLine]').val();
        var email = $('.data-capture-form #form input[name=Email1]').val();
        var company = $('.data-capture-form #form input[name=SingleLine3]').val();
        var phone = $('.data-capture-form #form input[name=PhoneNumber_countrycode]').val();
        if(name && email && company && phone){
          $('.data-capture-form #form #data_capture_download_btn').val('Download 2D CAD Block');
          $('.data-capture-form #form #data_capture_lead_source').val('Motionspot 2D CAD Block Download');
          location.href = $('.download-cad-block').not('.download-cad-block.hide').attr('data-link');
          setTimeout(function(){
              $('.data-capture-form #form').attr('action', 'https://forms.zohopublic.eu/motionspot/form/DownloadDataEntryFormMotionspot/formperma/-Yki3iPKCGKw54BUvQROjC6rxTwUNPNOYz47O0-jyZM/htmlRecords/submit');
              date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              $.cookie("dataCaptureCookie", 'yes_set', { expires : date });
              $('.data-capture-form #form').submit();

          },2000);
        }
      });
      $('.zoho_submit_button #zoho_download_doc_m').click(function(e){

        e.preventDefault();
        var name = $('.data-capture-form #form input[name=SingleLine]').val();
        var email = $('.data-capture-form #form input[name=Email1]').val();
        var company = $('.data-capture-form #form input[name=SingleLine3]').val();
        var phone = $('.data-capture-form #form input[name=PhoneNumber_countrycode]').val();
        if(name && email && company && phone){
          $('.data-capture-form #form #data_capture_download_btn').val('Download Product Specification(DOC M)');
          $('.data-capture-form #form #data_capture_lead_source').val('Motionspot Product Specification Download');
          Object.assign(document.createElement("a"), {
          target: "_blank",
          href: $('#download-doc-m-data').attr('data-link')
          }).click();

          setTimeout(function(){
              $('.data-capture-form #form').attr('action', 'https://forms.zohopublic.eu/motionspot/form/DownloadDataEntryFormMotionspot/formperma/-Yki3iPKCGKw54BUvQROjC6rxTwUNPNOYz47O0-jyZM/htmlRecords/submit');
              date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              $.cookie("dataCaptureCookie", 'yes_set', { expires : date });
              $('.data-capture-form #form').submit();

          },2000);
        }

      });

      span.onclick = function() {
        dataModal.style.display = "none";
        $('body').removeClass('open-data-capture-modal');
      }


    }

  // Download data capture popup form js end

  // whitepapers popup JS start
  if($('#whitepaperModal').length > 0){
      var modal = document.getElementById("whitepaperModal");
      var span = document.getElementsByClassName("close")[0];
      var cookie_hours = parseInt($('#whitepaper_cookie_hours').val());

      var is_set = jQuery.cookie('whitepaper');
      if(is_set != 'yes'){
        setTimeout(function(){
          modal.style.display = "flex";
          $('body').addClass('open-whitepaper-modal');
          // console.log(cookie_hours);
          var date = new Date();
          date.setTime(date.getTime() + (cookie_hours * 60 * 60 * 1000));
          $.cookie("whitepaper", 'yes', { expires : date });
        }, 1000);

      }


    span.onclick = function() {
      modal.style.display = "none";
      $('body').removeClass('open-whitepaper-modal');
    }
  }

    window.onclick = function(event) {
      if($('body').hasClass('open-whitepaper-modal')){
        if (event.target == modal) {
          modal.style.display = "none";
          $('body').removeClass('open-whitepaper-modal');
        }
      }
      if($('body').hasClass('open-data-capture-modal')){
          if (event.target == dataModal) {
            dataModal.style.display = "none";
            $('body').removeClass('open-data-capture-modal');
          }
      }
    }

  // whitepapers popup JS end


//     $('.product-catagloue-slider').owlCarousel({
//         margin: 40,
//         loop: true,
//         items: 1,
//         dots: true,
//         nav: true,
//         navigation: true,
//         slideBy: 3,

//         responsive: {
//             768: {
//                 items: 2,
//                 slideBy: 2,
//                 dots:true
//             },
//             1025: {
//                 items: 3,
//                 dots: true,
//                 slideBy: 3

//             }
//         }

//     });


//   var owl = $('.product-catagloue-slider');
//   owl.owlCarousel();
//   $('.owl-carousel-arrows-next').click(function() {
//     owl.trigger('next.owl.carousel');
//   });
//   $('.owl-carousel-arrows-prev').click(function() {
//     owl.trigger('prev.owl.carousel');
//   })




  $('.blog-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
    if (!e.namespace)  {
      return;
    }
    var carousel = e.relatedTarget;
    $(this).parent('.blog-slider-block').find('.slider-counter').text(carousel.relative(carousel.current()) + 1 + ' / ' + carousel.items().length);
  }).owlCarousel({
    items: 1,
    loop:true,
    margin:0,
    nav:true
  });




//   $('.blog-slider').owlCarousel({
//         margin: 40,
//         loop: true,
//         items: 1,
//         dots: true,
//         nav: true,
//         navigation: true,
//         responsive: {
//             768: {
//                  dots:false,
//             }
//         }

//     });

  /*	$('.product-main-popup').click(function(){
        $('#product-main-popup-id').show();

    });

	$('.close-modal').click(function(){
        $(this).closest('.product-page-banner-section').find('#product-main-popup-id').hide();
    });
  	*/


    /* back-top-button js start*/
    $('.back_top').click(function(e) {
        e.preventDefault();
        $("body,html").animate({
            scrollTop: 0
        }, 1200);
        return false;
    });

  	// var header_height=  $('.header').outerHeight();
  	// $(".headline-list li a").click(function (e){
    // 	e.preventDefault();
    // 	var boxid = $(this).attr("href");
    // 	var s1=$(boxid).offset().top - header_height	;
    // 		$("body,html").animate({
    // 				scrollTop: s1
    // 		},1200);
    // 		return false;
    // });

  // var header_height=  $('.header').outerHeight();
  // 	$(".image-grid .image-caption a").click(function (e){
  //   	e.preventDefault();
  //   	var boxid = $(this).attr("href");
  //   	var s1=$(boxid).offset().top - header_height	;
  //   		$("body,html").animate({
  //   				scrollTop: s1
  //   		},1200);
  //   		return false;
  //   });

  //  var header_height=  $('.header').outerHeight();
  // 	$(".description-list #stage-1 .sub-heading-listing li p a").click(function (e){
  //   	e.preventDefault();
  //   	var boxid = $(this).attr("href");
  //   	var s1=$(boxid).offset().top - header_height	;
  //   		$("body,html").animate({
  //   				scrollTop: s1
  //   		},1200);
  //   		return false;
  //   });

  /* tab key js */
//   $(".header .header-nav>ul>li>a").keydown(function (e) {
//   if (e.which == 9) {
//     $(".header .header-nav>ul>li>a").html(this.value);
//     this.value = "";
//     $(".header .header-nav>ul>li>a").focus();
//     e.preventDefault();
//   }
// });

//   $('.primary-btn').click(function(){

//     	console.log('hi');
//   });

//   $(".custom-row .custom-col .image-block i").click(function(){
// 		$(this).closest(".custom-col").find(".content").slideToggle();
// 	});


    /* back-top-button js end */
    setTimeout(function(){
//   		adj_mobile_nav();
      slide_emp_content();
  	},500);
    side_menu();
    sector_section();
    banner_section();
  openFilter();

  equalHeight();

});
$(window).on("load", function(){
    side_menu();
    banner_section();
  setTimeout(function(){
    slide_emp_content();
  },500);
  equalHeight();
  team_toggle();
  hover_submenu();
});


$(window).resize(function() {
  setTimeout(function(){
//   	adj_mobile_nav();
    slide_emp_content();
  },500);
    banner_section();

  equalHeight();
  team_toggle();
  hover_submenu();
});

// function adj_mobile_nav() {
//     if ($(window).width() < 768) {
//         var dot_left_offset = $(".product-catagloue-slider .owl-dots").offset().left;
//         var prev_position = dot_left_offset - ($(".product-catagloue-slider .owl-nav .owl-prev").width() + 40);
//         var next_position = dot_left_offset + $(".product-catagloue-slider .owl-dots").width();
//         $(".product-catagloue-slider .owl-nav .owl-prev").css("left", prev_position + "px");
//         $(".product-catagloue-slider .owl-nav .owl-next").css("left", next_position + "px");
//     }

// }
/*function slide_emp_content(){

    if($(window).width() < 992){
  $('.custom-row .custom-col .content').fadeOut();
  $('.custom-row .custom-col .image-block i').off().click(function(e){
    	$('.custom-row .custom-col').not($(this).closest('.custom-col')).removeClass('show');
    	$(this).closest('.custom-col').toggleClass('show');
    	$('.custom-row .custom-col .content').not($(this).closest('.custom-col').find('.content')).slideUp();
    	$(this).closest('.custom-col').find('.content').slideToggle();

  }); */
function slide_emp_content(){

    if($(window).width() < 1025){
  $('.custom-row .custom-col .content').fadeOut();
  $('.custom-row .custom-col .image-block i').off().click(function(e){
    	$('.custom-row .custom-col').not($(this).closest('.custom-col')).removeClass('show');
		$('.custom-row .custom-col').not($(this).closest('.custom-col')).find('.member_content').slideUp();
    	$(this).closest('.custom-col').toggleClass('show');
		$(this).closest('.custom-col').find('.member_content').slideToggle();
    	$('.custom-row .custom-col').not($(this).closest('.custom-col')).find('.content').slideUp();
    	$(this).closest('.custom-col').find('.content').slideToggle();


  });
      	$('.member_truncate_content').hide();
    	$('.readmore').hide();

    /*$('.our-clients-section .container .image-block:last-child').fadeOut();
  	$('.view-item').click(function(){
    	$('.our-clients-section').toggleClass('show-image');
    	$('.our-clients-section .container .image-block:last-child').fadeToggle();

  });*/
    }else{
      $('.member_truncate_content').show();
      $('.readmore').show();
      $('.member-biodata').show();
      $('.custom-row .custom-col').removeClass('show');

    }
}
// function adj_mobile_nav() {
//       if ($(window).width() < 768) {
//       if($(".owl-dots").length > 0){
//         var dot_left_offset = $(".owl-dots").offset().left;
//         var prev_position = dot_left_offset - ($(".owl-nav .owl-prev").width() + 40);
//         var next_position = dot_left_offset + $(".owl-dots").width();
//         $(".owl-nav .owl-prev").css("left", prev_position + "px");
//         $(".owl-nav .owl-next").css("left", next_position + "px");
//       }
//     }else{

//       	$(".owl-nav .owl-prev").css("left", "");
//         $(".owl-nav .owl-next").css("left", "");

//       }

// }


function side_menu() {

    $(".header .mobile-nav-wrapper .site-header__menu,.site-header__menu-outer").click(function() {
        $('.mobile-nav-wrapper').removeClass('js-menu--is-open');
        $(".site-header__icons .btn--link").removeClass("mobile-nav--close");
        $(".site-header__icons .btn--link").addClass("mobile-nav--open");
    });

    $('.site-header__menu').click(function() {
        $('body').toggleClass('open');
    });
}


function fixed_heder() {
    var header_height = $('.header').outerHeight();
    $('.main-content').css('padding-top', header_height);
  // console.log("fix-header");
}



function sector_section() {
  if($('.sectors-section').length > 0){
    var block_offset = $('.sectors-section').offset().top;
    // console.log(block_offset);
    $('.learn-more-link').click(function() {
        $("body,html").animate({
            scrollTop: block_offset
        }, 1200);
    });
  }
}

function banner_section() {


    if ($(window).width() > 1279) {
        var header_height = $(".site-header").height();
        var window_height = $(window).height();
        var banner_height = window_height - header_height
        $('.home-banner .banner-inner-wrapper').css('height', banner_height + "px");
    } else {
        $('.home-banner .banner-inner-wrapper').css('height', "auto");
    }

}


/* collection page */


function openFilter(){
//   var element=document.getElementById("filter-block");
//   element.style.display="block";
  $(".filter-btn").click(function(){
    $("body , html").toggleClass("open-filter");
  });
  $(".close-container .img-block").click(function(){
    $("body , html").removeClass("open-filter");
  });
  $(".overlay").click(function(){
    $("body , html").removeClass("open-filter");
  });
}

// function closeFilter(){
//   var cls=document.getElementById("filter-block");
//   cls.style.display="none";
// }


$(document).click(function(event) {
   if (!$(event.target).closest(".product-modal-content").length && !$(event.target).closest(".product-main-popup").length) {
      if($('.product-modal').css('display') == 'block'){
     		$('.product-modal').hide();
       }
	}
});


/*product page modal */
function openModal(n) {

   $('.product-modal').show();
   var alttext = n;

  $('.slides').each(function(){
  var altt = $(this).attr('alt');
    if(alttext == altt){

        $(this).css({"display": "block"});
      	var scount = $(this).attr('count');
      	$('.demo').removeClass('active');
      	dotsSlides(scount);
       }
    else{
    $(this).css({"display": "none"});
    }
  });

}

function closeModal() {
  $('.product-modal').hide();

}
        //  console.log($('.product-modal').css('display'));


var slideIndex = 1;


function plusSlides(n) {
  showSlides(slideIndex += n);
}

function currentSlide(n) {
  showSlides(slideIndex = n);
}

function dotsSlides(n){
  var i;
  var dots = $(".product-modal .demo");
  for (i = 0; i < dots.length; i++) {
     dots[i].className = dots[i].className.replace(" active", "");
  }
dots[n-1].className += " active";

}

function showSlides(n) {


  var i;
  var slides = document.getElementsByClassName("slides");
  var dots = $(".product-modal .demo");
  if (n > slides.length) {slideIndex = 1}
  if (n < 1) {slideIndex = slides.length}
  for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
     dots[i].className = dots[i].className.replace(" active", "");
  }
  slides[slideIndex-1].style.display = "block";
  dots[slideIndex-1].className += " active";

}

// lightbox key arrows

$(document).on('keyup.slider', function(evt) {
   if (evt.keyCode == 37) {
        $('.product-modal .prev-modal').trigger('click');
    } else if (evt.keyCode == 39) {
        $('.product-modal .next-modal').trigger('click');
    }
});
/* carousel pagination */

$('.product-catagloue-slider').on('initialized.owl.carousel changed.owl.carousel', function(e) {
    if (!e.namespace)  {
      return;
    }
    var carousel = e.relatedTarget;

    $(this).parent('.product-catagloue-outer').find('.slider-counter').text(carousel.relative(carousel.current()) + 1 + ' / ' + carousel.items().length);
  }).owlCarousel({
    items: 3,
    loop:true,
  	margin:32,
    nav:true,
  	responsive: {
            320: {
               items: 1,
               slideBy: 1,

            },
            768: {
                items: 2,
                slideBy: 1
			},
      	   1025: {
                items: 3,
                slideBy: 1
           }
       }

  });
// $('.product-catagloue-slider').on('.owl.carousel', function(e) {
//     if (!e.namespace)  {
//       return;
//     }
//     var carousel = e.relatedTarget;
//     $('.slider-counter').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
//   }).owlCarousel({
//     items: 1,
//     loop:true,
//     margin:0,
//     nav:true
//   });


/*product page banner slider*/

$('.outer_product_slider').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
   	items:3,
  	slideBy: 1
})


/*extra arrows in sliders*/

  $('.product-catagloue-section .owl-carousel-arrows-next').click(function() {
     $(".product-catagloue-slider").trigger('next.owl.carousel');
   });
  $('.product-catagloue-section .owl-carousel-arrows-prev').click(function() {
    $(".product-catagloue-slider").trigger('prev.owl.carousel');
  })
  $('.blog-headline-section .owl-carousel-arrows-next').click(function() {
      $(".blog-slider").trigger('next.owl.carousel');
  });
  $('.blog-headline-section .owl-carousel-arrows-prev').click(function() {
     $(".blog-slider").trigger('prev.owl.carousel');
  })
